import PropTypes from 'prop-types'
import { HStack, Text } from '@chakra-ui/react'
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

export default function IconHeader({ label, isSort, sortBy, column }) {
  return (
    <HStack justifyContent="space-between">
      <Text>{label}</Text>
      {sortBy === column.sortBy?.toUpperCase() &&
        (isSort || isSort === false) && (
          <FontAwesomeIcon icon={isSort ? faAngleUp : faAngleDown} />
        )}
    </HStack>
  )
}

IconHeader.propTypes = {
  column: PropTypes.shape({
    id: PropTypes.any,
    label: PropTypes.any,
    sortBy: PropTypes.string,
  }),
  isSort: PropTypes.bool,
  label: PropTypes.string,
  sortBy: PropTypes.string,
}
